
			// Set up analytics settings for the React provider to use
			window.analyticsSettings = {
				amplitude: {
					apiKey: import.meta.env.VITE_AMPLITUDE_API_KEY,
				},
				datadog: {
					clientToken: "pub2b934a28320e9a4d07d0df53de315d70",
					site: "datadoghq.eu",
					service: "app",
					env: import.meta.env.VITE_ENV,
					version: import.meta.env.VITE_AWS_COMMIT_ID,
					forwardConsoleLogs: ["error", "warn"],
				},
				google: {
					analyticsId: import.meta.env.VITE_GOOGLE_ANALYTICS_ID,
				},
			}

			document.addEventListener("DOMContentLoaded", function (event) {
				var cpm = {
					onInitialise: function (status) {
						window.dispatchEvent(new Event("cookiehub:consent-saved"))
					},
					onStatusChange: function (status, previousStatus) {
						window.dispatchEvent(new Event("cookiehub:consent-changed"))
					},
				}

				window.cookiehub.load(cpm)
			})
		